import { Button, FileButton, Group, Text, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { fieldMapsApi } from '@fields/data-access';

interface UploadSamplesMapFormProps {
  fieldId: number;
  onClose?: () => void;
}

export const UploadSamplesMapForm: React.FC<UploadSamplesMapFormProps> = ({
  fieldId,
  onClose,
}) => {
  const { t } = useTranslation();
  const form = useForm({
    initialValues: {
      name: '',
      file: null as File | null,
    },
    validate: {
      file: (value) =>
        value ? null : t('form.vous-devez-selectionner-un-fichier'),
    },
  });

  const uploadSampleMap = useMutation({
    mutationFn: fieldMapsApi.uploadSampleMap,
  });

  type FormValues = typeof form.values;

  const handleSubmit = (values: FormValues) => {
    if (values.file !== null) {
      uploadSampleMap.mutate(
        {
          fieldId,
          name: values.name,
          file: values.file,
        },
        {
          onSettled: () => {
            form.reset();
            onClose?.();
          },
        },
      );
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <TextInput
        label={t('field.form.mapNameLabel')}
        {...form.getInputProps('name')}
        required
      />

      <FileButton {...form.getInputProps('file')}>
        {(props) => (
          <Button {...props} mt="md">
            {t('common.selectionner-un-fichier')}
          </Button>
        )}
      </FileButton>
      {form.errors.file ? (
        <Text c="red" size="sm">
          {form.errors.file}
        </Text>
      ) : null}
      {form.values.file ? (
        <Text mt="sm" size="sm">
          {t('field.form.fileSelected')} {form.values.file.name}
        </Text>
      ) : null}

      <Group justify="start" mt="md">
        <Button loading={uploadSampleMap.isPending} type="submit">
          {t('common.add')}
        </Button>
        <Button color="red" onClick={onClose} type="button">
          {t('common.back')}
        </Button>
      </Group>
    </form>
  );
};

export default UploadSamplesMapForm;
